import { render, staticRenderFns } from "./GameCheats.vue?vue&type=template&id=05e15daf"
import script from "./GameCheats.vue?vue&type=script&lang=js"
export * from "./GameCheats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,RelatedLinks: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/RelatedLinks/RelatedLinks.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default})
